import "reflect-metadata";
import { Exclude, Expose } from "class-transformer";
import { IsDefined, IsNumber } from "class-validator";

import { GField, GFloat, GInputType, GObjectType } from "../graphql";

@GInputType("LocationPositionInput")
@GObjectType("LocationPosition")
@Exclude()
export class LocationPosition {
  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public latitude: number;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public longitude: number;

  public constructor(latitude: number, longitude: number) {
    this.latitude = latitude;
    this.longitude = longitude;
  }

  public latLongToString(): string {
    return `${this.latitude}, ${this.longitude}`;
  }
}
